// extracted by mini-css-extract-plugin
module.exports = {"flexEnd":"future-deliveries_flexEnd__3YhRs","showMore":"future-deliveries_showMore__ZIX39"};